import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'crop'
})
export class CropImagePipe implements PipeTransform {
  constructor() {}

  transform(url: string, width?: string, height?: string): string {
    url += `?${width ? `width=${width}&` : ''}${
      height ? `height=${height}&` : ''
    }mode=CropUpsize&quality=90`;

    if (url.indexOf(')&')) {
      return url.split(')&').join('&');
    }
    return url;
  }
}
